import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';

import { MatSelectChange } from '@angular/material/select';
import { TipoRol } from '@rpe/registro-personas-empresas-lib';

import {
  CorreoElectronico,
  FormActionType
} from '@rpe/registro-personas-empresas-lib';
import { DireccionesGeograficasFormComponent } from '../../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';

import {
  PersonaJuridicaFormInput,
  RPEPersonaJuridica
} from '../entity-personas-juridica.model';
import { certificado_notarial_tooltip } from 'projects/registro-personas-empresas/src/app/shared/util/util';
import { TelefonosFormComponent } from '../../../contactos/telefonos/components/telefonos-form.component';
import {
  Telefono,
  TelefonoFormInput
} from '../../../contactos/telefonos/telefonos.model';
import { DireccionGeografica } from '../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';
import { Subscription } from 'rxjs';

import { OverlayMatIcon } from 'projects/registro-personas-empresas/src/app/shared/mat-icon-tooltip/mat-icon';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { entityEmpresaDGILoadRequest, entityEmpresaDGISetEmpty } from '../../empresas-dgi/empresas-dgi.actions';
import { selectEmpresaDGI, selectEmpresaDGIError, selectEmpresaDGIIsLoading } from '../../empresas-dgi/empresas-dgi.selectors';
import { filter, debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { EmpresaDGI, Domicilio } from '../../empresas-dgi/empresas-dgi.model';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';

@Component({
  selector: 'rpe-persona-juridica-form',
  templateUrl: './persona-juridica-form.component.html',
  styleUrls: ['./persona-juridica-form.component.scss']
})
export class PersonaJuridicaFormComponent implements OnInit, OnDestroy {
  @Input() set formInput(personaJuridicaFormInput: PersonaJuridicaFormInput) {
    this._formInput = personaJuridicaFormInput;
    this.listaRoles = personaJuridicaFormInput.tipos_rol;

    if (personaJuridicaFormInput?.persona_juridica?.certificado_notarial) {
      this.linkCertificadoNotarial = `${personaJuridicaFormInput.persona_juridica.certificado_notarial}`;
    }

    if (personaJuridicaFormInput?.rol?.acreditacion_representacion) {
      this.acreditacionRepresentacionLink = `${personaJuridicaFormInput.rol.acreditacion_representacion}`;
      this.acreditacionOculta = false;
    }

    if (personaJuridicaFormInput.entidad_productiva) {
      this.direccionGeograficaFiscalFormInput =
        personaJuridicaFormInput.entidad_productiva.direccion_geografica_fiscal;
      this.direccionGeograficaFiscal =
        personaJuridicaFormInput.entidad_productiva.direccion_geografica_fiscal;
      this.direccionGeograficaCorrespondencia =
        personaJuridicaFormInput.entidad_productiva.direccion_geografica_correspondencia;

      if (
        this.direccionGeograficaFiscal.direccion ===
        personaJuridicaFormInput.entidad_productiva
          .direccion_geografica_constituida.direccion
      ) {
        this.mismoDomicilioFiscal = 'si';
        this.direccionGeograficaOficinaFormInput =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_constituida;
        this.direccionGeograficaOficina =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_constituida;
      } else {
        this.mismoDomicilioFiscal = 'no';
        this.direccionGeograficaOficinaFormInput =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_constituida;
        this.direccionGeograficaOficina =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_constituida;
      }

      if (
        this.direccionGeograficaCorrespondencia.direccion ===
        personaJuridicaFormInput.entidad_productiva
          .direccion_geografica_constituida.direccion
      ) {
        this.mismoDomicilioCorrespondencia = 'si';
        this.direccionGeograficaCorrespondenciaFormInput =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_correspondencia;
        this.direccionGeograficaCorrespondencia =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_correspondencia;
      } else {
        this.mismoDomicilioCorrespondencia = 'no';
        this.direccionGeograficaCorrespondenciaFormInput =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_correspondencia;
        this.direccionGeograficaCorrespondencia =
          personaJuridicaFormInput.entidad_productiva.direccion_geografica_correspondencia;
      }
    }

    if (this._formInput.persona_juridica?.rut) {
      this.onRutStatusChange.emit(true);
    }

    if (personaJuridicaFormInput) {
      this.telefonosStatus = 'VALID';
    }

    //Actualizo la dir del form
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChangesRPEPJ = new EventEmitter<RPEPersonaJuridica>();
  @Output() onRutStatusChange = new EventEmitter<boolean>();
  @Output() onDGILoadedChange = new EventEmitter<boolean>();

  // @ViewChild(DireccionGeograficaFormComponent, { static: true })
  // direccionGeograficaForm: DireccionGeograficaFormComponent;

  @ViewChild('direccion_geografica_constituida', { static: true })
  direccion_geografica_constituida: DireccionesGeograficasFormComponent;
  direccionGeograficaOficinaFormInput: DireccionGeografica = null;
  direccionGeograficaOficina: DireccionGeografica = null;
  direccionGeograficaOficinaValid: boolean = false;

  @ViewChild('direccion_geografica_correspondencia', { static: true })
  direccion_geografica_correspondencia: DireccionesGeograficasFormComponent;
  direccionGeograficaCorrespondenciaFormInput: DireccionGeografica = null;
  direccionGeograficaCorrespondencia: DireccionGeografica = null;
  direccionGeograficaCorrespondenciaValid: boolean = false;

  @ViewChild('direccion_geografica_fiscal', { static: true })
  direccion_geografica_fiscal: DireccionesGeograficasFormComponent;
  direccionGeograficaFiscalFormInput: DireccionGeografica = null;
  direccionGeograficaFiscal: DireccionGeografica = null;
  direccionGeograficaFiscalValid: boolean = false;

  @ViewChild(TelefonosFormComponent, { static: true })
  telefonosFormComponent: TelefonosFormComponent;
  formInputTelefono: TelefonoFormInput;
  telefonosStatus: string;
  telefonos: Telefono[];

  _formInput: PersonaJuridicaFormInput = null;
  personaJuridicaFormGroup: FormGroup;
  mismoDomicilioCorrespondencia: string = 'si';
  mismoDomicilioFiscal: string = 'si';

  direccion_geografica_fiscal_form: FormGroup;
  direccion_geografica_correspondencia_form: FormGroup;

  listaRoles: TipoRol[] = [];

  subscriptions: Subscription[] = [];

  linkCertificadoNotarial: string = '';
  acreditacionRepresentacionLink: string = '';

  modificarParam: boolean = false;
  hideCertificadoNotarial = false;

  get email_administrativo() {
    return this.personaJuridicaFormGroup.get(
      'email_administrativo'
    ) as FormArray;
  }

  get email_facturacion() {
    return this.personaJuridicaFormGroup.get('email_facturacion') as FormArray;
  }

  get formInput(): PersonaJuridicaFormInput {
    return this._formInput;
  }

  get rolWithoutTitular(): TipoRol[] {
    return this.formInput.tipos_rol.filter((rol) => rol.id != 1);
  }

  get rolWithTitular(): TipoRol[] {
    return this.formInput.tipos_rol;
  }

  get certificadoNotarialTooltip(): string {
    return certificado_notarial_tooltip;
  }

  overlayInput: OverlayMatIcon = {
    text: this.certificadoNotarialTooltip,
    icon: 'info'
  };

  empresaDGILoaded = false;
  // indica que se ingresaron los datos manualmente por fallo de conexion con DGI
  entradaManual = false;
  // indica que se ejecuto una consulta a DGI (evita reaccionar a estados previos del store)
  dgiConsultada = false;
  empresaDGIIsLoading$ = this.store.select(selectEmpresaDGIIsLoading);

  // determina si mostrar el formulario completo o solo el campo rut
  get mostrarFormularioCompleto(): boolean {
    if (this.formInput.action !== FormActionType.Add) {
      return true;
    }
    return this.empresaDGILoaded;
  }

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private store: Store<State>,
    private notificationService: NotificationService
  ) {
    this.modificarParam = this.activatedRoute.snapshot.queryParams.modificar;
  }

  acreditacionOculta = true;

  dateValidator(control: FormGroup): { [s: string]: boolean } {
    if (control.value) {
      const date = new Date(control.value);
      const today = new Date();
      if (date > today) {
        return { invalidDate: true };
      }
    }
    return null;
  }

  lengthValidator(minLength: number, maxLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value?.toString();
      const length = value ? value.length : 0;
      return length >= minLength && length <= maxLength
        ? null
        : { lengthInvalid: { value: control.value } };
    };
  }

  numericValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const valid = /^\d+$/.test(control.value);
      return valid ? null : { numericInvalid: { value: control.value } };
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.direccion_geografica_fiscal_form =
      this.direccion_geografica_fiscal.createGroup();
    this.direccion_geografica_correspondencia_form =
      this.direccion_geografica_correspondencia.createGroup();

    // Creacion de nueva personaJuridica
    if (this.formInput.action == FormActionType.Add) {
      this.formInputTelefono = {
        defaultPais: null,
        preSelectPais: 'uy',
        telefonos: null
      };
      this.personaJuridicaFormGroup = this.fb.group({
        persona_juridica: this.fb.group({
          denominacion_social: [{value: '', disabled: true}, [Validators.required]],
          nombre_fantasia: [{value: '', disabled: true}, []],
          rut: [
            '',
            [
              Validators.required,
              this.lengthValidator(12, 12),
              this.numericValidator()
            ]
          ],
          bps: ['', [Validators.required]],
          certificado_notarial: [null, [Validators.required]],
          naturaleza_juridica_id: ['', [Validators.required]]
        }),
        entidad_productiva: this.fb.group({
          id: [null, []],
          rgs: [null, []],
          estado: [1, []], // EstadoEntidadProductiva
          autoregistrada: [true, []],
          correos_electronico: [null, []],
          direccion_geografica_constituida:
            this.direccion_geografica_correspondencia_form,
          direccion_geografica_correspondencia:
            this.direccion_geografica_correspondencia_form,
          direccion_geografica_fiscal:
            this.direccion_geografica_fiscal.createGroup(),
          actividades: [[], []],
          persona_fisica_id: [null, []],
          persona_juridica_id: [null, []]
        }),
        rol: this.fb.group({
          persona_id: [this.formInput.id_persona_logueada, []], //aca va el id de la persona logueada
          entidad_productiva_id: [null, []],
          acreditacion_representacion: [null, [Validators.required]],
          es_creador: [true, []],
          fecha_alta: [new Date().toISOString().split('T')[0], []],
          fecha_baja: [null, []],
          vinculo_aprobado_rol: [true, []],
          vinculo_aprobado_entidad_productiva: [true, []],
          eliminado: [false, []],
          tipo_rol_id: [null, []]
        }),
        email_tecnico: this.fb.array([
          this.fb.control(null, [Validators.required, emailValidator])
        ]),
        email_administrativo: this.fb.array([
          this.fb.control(null, [Validators.required, emailValidator])
        ]),
        email_facturacion: this.fb.array([
          this.fb.control(null, [Validators.required, emailValidator])
        ])
      });
    } else {
      this.formInputTelefono = {
        defaultPais: null,
        preSelectPais: 'uy',
        telefonos: this._formInput.entidad_productiva.telefonos
      };
      const emailTecnico =
        this._formInput.entidad_productiva.correos_electronico.filter((ce) => {
          return ce.tipo_correo_id === 1;
        });

      const emailAdminsitrativo =
        this._formInput.entidad_productiva.correos_electronico.filter((ce) => {
          return ce.tipo_correo_id === 2;
        });

      const emailFacturacion =
        this._formInput.entidad_productiva.correos_electronico.filter((ce) => {
          return ce.tipo_correo_id === 3;
        });

      this.personaJuridicaFormGroup = this.fb.group({
        persona_juridica: this.fb.group({
          denominacion_social: [
            this._formInput.persona_juridica.denominacion_social,
            [Validators.required]
          ],
          nombre_fantasia: [
            this._formInput.persona_juridica.nombre_fantasia,
            []
          ],
          rut: [
            this._formInput.persona_juridica.rut,
            [Validators.required, this.lengthValidator(12, 12)]
          ],
          bps: [this._formInput.persona_juridica.bps, [Validators.required]],
          certificado_notarial: [
            this._formInput.persona_juridica.certificado_notarial,
            []
          ],
          naturaleza_juridica_id: [
            this._formInput.persona_juridica.naturaleza_juridica_id,
            [Validators.required]
          ]
        }),
        entidad_productiva: this.fb.group(this._formInput.entidad_productiva),
        rol: this.fb.group(this.formInput.rol),
        email_tecnico:
          emailTecnico.length > 0
            ? this.fb.array(
                emailTecnico.map((ce) => {
                  return this.fb.control(ce.direccion, [
                    Validators.required,
                    emailValidator
                  ]);
                })
              )
            : this.fb.array([
                this.fb.control(null, [Validators.required, emailValidator])
              ]),
        email_administrativo:
          emailAdminsitrativo.length > 0
            ? this.fb.array(
                emailAdminsitrativo.map((ce) => {
                  return this.fb.control(ce.direccion, [
                    Validators.required,
                    emailValidator
                  ]);
                })
              )
            : this.fb.array([
                this.fb.control(null, [Validators.required, emailValidator])
              ]),
        email_facturacion:
          emailFacturacion.length > 0
            ? this.fb.array(
                emailFacturacion.map((ce) => {
                  return this.fb.control(ce.direccion, [
                    Validators.required,
                    emailValidator
                  ]);
                })
              )
            : this.fb.array([
                this.fb.control(null, [Validators.required, emailValidator])
              ])
      });

      this.personaJuridicaFormGroup
        .get('persona_juridica')
        .get('certificado_notarial')
        .clearValidators();

      this.onNaturalezaJuridicaChange(
        this._formInput.persona_juridica.naturaleza_juridica_id
      );

      if (this.modificarParam) {
        /// persona_juridica
        this.personaJuridicaFormGroup.get('persona_juridica').disable();

        /// roles
        this.personaJuridicaFormGroup.get('rol').disable();
      }

      //naturalezaJuridicaInit
      this.hideCertificadoNotarial = this.onHideCertificadoNotarial(
        this._formInput.persona_juridica.naturaleza_juridica_id
      );
      this.addNaturalezaJuridicaValidators();
    }

    //se deshabilita inicialmente la direccion de correspondencia
    this.personaJuridicaFormGroup
      .get('entidad_productiva')
      .get('direccion_geografica_correspondencia')
      .disable();

    this.personaJuridicaFormGroup
      .get('entidad_productiva')
      .get('direccion_geografica_fiscal')
      .disable();

    // emit events
    const s1 = this.personaJuridicaFormGroup.valueChanges.subscribe((_) => {
      this.onChangeFormEmit();
    });

    const s2 = this.personaJuridicaFormGroup
      .get('persona_juridica')
      .get('naturaleza_juridica_id')
      .valueChanges.subscribe((naturaleza_juridica_id) => {
        this.onNaturalezaJuridicaChange(naturaleza_juridica_id);
        // Valido si hay que ocultar el certificado notarial
        this.hideCertificadoNotarial = this.onHideCertificadoNotarial(
          naturaleza_juridica_id
        );
        // Agrego o quito validaciones al certificado notarial
        this.addNaturalezaJuridicaValidators();
      });

    const s3 = this.personaJuridicaFormGroup
      .get('persona_juridica')
      .get('rut')
      .statusChanges.subscribe((status) => {
        this.onRutStatusChange.emit(status === 'VALID');
      });

    const s4 = this.personaJuridicaFormGroup.statusChanges.subscribe((_) => {
      this.emitFormStatusChanges();
    });

    if (this.formInput.action == FormActionType.Add) {
      const rutControl = this.personaJuridicaFormGroup.get('persona_juridica').get('rut');
      
      // resetea campos cuando cambia el rut
      const s5 = rutControl.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(rut => {
        this.resetDGIFields();
      });

      // escucha los datos de dgi cuando se cargan exitosamente
      const s6 = this.store.select(selectEmpresaDGI).pipe(
        filter(empresa => empresa !== null)
      ).subscribe((empresaDGI: EmpresaDGI | null) => {
        if (empresaDGI && this.formInput.action == FormActionType.Add) {
          const currentRut = rutControl.value;
          
          if (!empresaDGI.RUT || empresaDGI.RUT.trim() === '') {
            this.notificationService.error('No se encontró la empresa con el RUT ingresado en DGI.');
            this.empresaDGILoaded = false;
            this.onDGILoadedChange.emit(false);
           
            return;
          }
          
          if (currentRut && currentRut.length === 12 && empresaDGI.RUT === currentRut) {
            this.loadDGIData(empresaDGI);
          }
        }
      });

      // escucha los errores de conexion con dgi para habilitar el ingreso manual
      const s7 = this.store.select(selectEmpresaDGIError).pipe(
        filter((error) => error !== null && error !== undefined)
      ).subscribe(() => {
        if (
          this.formInput.action == FormActionType.Add &&
          this.dgiConsultada &&
          !this.empresaDGILoaded
        ) {
          this.notificationService.warn(
            'No se pudo establecer conexión con DGI. Puede ingresar los datos de la empresa manualmente.'
          );
          this.enableManualEntry();
        }
      });

      this.subscriptions.push(s5, s6, s7);
    }

    this.subscriptions.push(s1, s2, s3, s4);
  }

  onFileChange(texto: string) {}

  addNaturalezaJuridicaValidators() {
    if (this.hideCertificadoNotarial) {
      this.personaJuridicaFormGroup
        .get('persona_juridica')
        .get('certificado_notarial')
        .clearValidators();
    } else {
      this.personaJuridicaFormGroup
        .get('persona_juridica')
        .get('certificado_notarial')
        .setValidators([Validators.required]);
    }

    this.personaJuridicaFormGroup
      .get('persona_juridica')
      .get('certificado_notarial')
      .updateValueAndValidity();
  }

  onHideCertificadoNotarial(naturalezaJuridicaId: any): boolean {
    // Ocultar certificado notarial | lastUpdate 15/08/2024
    // 15 (Unipersonal
    const data: { [key: number]: boolean } = {
      [`${15}`]: true
    };

    if (!data[naturalezaJuridicaId]) {
      return false;
    }

    if (!naturalezaJuridicaId) {
      return false;
    }

    return (data as any)[naturalezaJuridicaId];
  }

  onNaturalezaJuridicaChange($event: number) {
    const naturalezaJuridica = this.formInput.naturalezas_juridicas.find(
      (nj) => nj.id === $event
    );

    if (naturalezaJuridica.id != 15) {
      this.listaRoles = this.rolWithoutTitular;
    } else {
      this.listaRoles = this.rolWithTitular;
    }
  }

  onChangeFormEmit(): void {
    let correos_electronico: CorreoElectronico[] = [];

    //voy tomando los correos y creo los tipos correspondientes
    let auxCorreos: string[] =
      this.personaJuridicaFormGroup.get('email_tecnico').value;
    auxCorreos.forEach((direccion) => {
      let correo: CorreoElectronico = {
        id: null,
        direccion: direccion,
        tipo_correo_id: 1
      };
      correos_electronico.push(correo);
    });
    auxCorreos = this.personaJuridicaFormGroup.get(
      'email_administrativo'
    ).value;
    auxCorreos.forEach((direccion) => {
      let correo: CorreoElectronico = {
        id: null,
        direccion: direccion,
        tipo_correo_id: 2
      };
      correos_electronico.push(correo);
    });
    auxCorreos = this.personaJuridicaFormGroup.get('email_facturacion').value;
    auxCorreos.forEach((direccion) => {
      let correo: CorreoElectronico = {
        id: null,
        direccion: direccion,
        tipo_correo_id: 3
      };
      correos_electronico.push(correo);
    });
    //si es la misma direccion se copia la de oficina a correspondencia
    let auxDirCorrespondencia = this.direccionGeograficaCorrespondencia;
    let auxDirFiscal = this.direccionGeograficaFiscal;

    if (this.mismoDomicilioFiscal == 'si') {
      this.direccion_geografica_fiscal_form = this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_constituida') as FormGroup;

      auxDirFiscal = this.direccionGeograficaOficina;
      this.direccionGeograficaFiscalFormInput = null;
    } else {
      // this.direccionGeograficaFiscalFormInput =
      //   this.direccion_geografica_fiscal.createGroup().value;
    }

    if (this.mismoDomicilioCorrespondencia == 'si') {
      this.direccion_geografica_correspondencia_form =
        this.personaJuridicaFormGroup
          .get('entidad_productiva')
          .get('direccion_geografica_constituida') as FormGroup;

      auxDirCorrespondencia = this.direccionGeograficaOficina;
      this.direccionGeograficaCorrespondenciaFormInput = null;
    } else {
      // this.direccionGeograficaCorrespondenciaFormInput =
      //   this.direccion_geografica_correspondencia.createGroup().value;
    }

    // this.personaJuridicaFormGroup.get('entidad_productiva').get('direccion_geografica_correspondencia').setValue(auxDirCorrespondencia)
    // this.personaJuridicaFormGroup.get('entidad_productiva').get('direccion_geografica_fiscal').setValue(auxDirFiscal)

    this.formValueChangesRPEPJ.emit({
      persona_juridica:
        (this.personaJuridicaFormGroup.get('persona_juridica') as FormGroup).getRawValue(),
      rol: (this.personaJuridicaFormGroup.get('rol') as FormGroup).getRawValue(),
      entidad_productiva: {
        ...(this.personaJuridicaFormGroup.get('entidad_productiva') as FormGroup).getRawValue(),
        direccion_geografica_constituida: this.direccionGeograficaOficina,
        direccion_geografica_correspondencia: auxDirCorrespondencia
          ? auxDirCorrespondencia
          : this.direccionGeograficaCorrespondencia,
        direccion_geografica_fiscal: auxDirFiscal
          ? auxDirFiscal
          : this.direccionGeograficaFiscal,
        telefonos: this.telefonos,
        correos_electronico: correos_electronico
      }
    });

    this.emitFormStatusChanges();
  }

  emitFormStatusChanges() {
    const status =
      this.personaJuridicaFormGroup?.valid &&
      this.telefonosStatus == 'VALID' &&
      this.direccionGeograficaOficinaValid;
    this.formStatusChanges.emit(status ? 'VALID' : 'INVALID');
  }

  cambioTipoRol(event: MatSelectChange) {
    let tipoRolId = event.value;
    // solo se muestra en caso de que sea apoderado o representante en otro caso se oculta
    this.acreditacionOculta =
      tipoRolId != 3 && tipoRolId != 5 && tipoRolId != 4;

    if (this.acreditacionOculta) {
      // this.personaJuridicaFormGroup.get("rol").get("acreditacion_representacion").disable();
      this.personaJuridicaFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .clearValidators();
    } else {
      // this.personaJuridicaFormGroup.get("rol").get("acreditacion_representacion").enable();
      this.personaJuridicaFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .setValidators([Validators.required]);
    }
    this.personaJuridicaFormGroup
      .get('rol')
      .get('acreditacion_representacion')
      .updateValueAndValidity();
  }

  ocultarAcreditacion() {
    return this.acreditacionOculta;
  }

  ocultarOtraDireccion() {
    return this.mismoDomicilioCorrespondencia == 'si';
  }

  ocultarOtraDireccionFiscal() {
    return this.mismoDomicilioFiscal == 'si';
  }

  handleChangeDomicilioCorrespondencia(event: any) {
    this.mismoDomicilioCorrespondencia = event.value;
    if (this.mismoDomicilioCorrespondencia == 'si') {
      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_correspondencia')
        .disable();
    } else {
      //se limpia el formulario y se habilitan las validaciones
      // this.personaJuridicaFormGroup.get('entidad_productiva').get('direccion_geografica_correspondencia').setValue({ ...this.direccionGeograficaCorrespondenciaFormInput, pais_codigo: 'uy' })

      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_correspondencia')
        .enable();
      // this.direccion_geografica_correspondencia.limpiarCampos();
    }
  }

  handleDireccionGeograficaFiscal(event: any) {
    this.mismoDomicilioFiscal = event.value;
    if (this.mismoDomicilioFiscal == 'si') {
      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_fiscal')
        .disable();
    } else {
      //se limpia el formulario y se habilitan las validaciones
      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_fiscal')
        .enable();
      // this.direccion_geografica_fiscal.limpiarCampos();
    }
  }

  agregarOtroEmailTecnico() {
    const fcET: FormControl = this.fb.control(null, [
      Validators.required,
      emailValidator
    ]);
    this.email_tecnico.push(fcET);
  }
  eliminarUnEmailTecnico(index: number) {
    this.email_tecnico.removeAt(index);
  }
  get email_tecnico() {
    return this.personaJuridicaFormGroup.get('email_tecnico') as FormArray;
  }

  agregarOtroEmailAdministrativo() {
    this.email_administrativo.push(
      this.fb.control(null, [Validators.required, emailValidator])
    );
  }

  eliminarUnEmailAdministrativo(index: number) {
    this.email_administrativo.removeAt(index);
  }

  agregarOtroEmailFacturacion() {
    this.email_facturacion.push(
      this.fb.control('', [Validators.required, emailValidator])
    );
  }
  eliminarUnEmailFacturacion(index: number) {
    this.email_facturacion.removeAt(index);
  }

  reset(): void {}

  onShowErrors(): void {
    this.personaJuridicaFormGroup.markAllAsTouched();
    this.telefonosFormComponent.checkErrors();
    this.direccion_geografica_constituida.checkErrors();
    this.direccion_geografica_fiscal.checkErrors();
    this.direccion_geografica_correspondencia.checkErrors();
  }

  /* DIRECCIONES GEOGRAFICAS*/
  direccionGeograficaOficinaChange(dg: any) {
    this.direccionGeograficaOficina = dg;
    this.onChangeFormEmit();
  }

  direccionGeograficaFiscalChange(dg: any) {
    this.direccionGeograficaFiscal = dg;
    this.onChangeFormEmit();
  }

  direccionGeograficaCorrespondenciaChange(dg: any) {
    this.direccionGeograficaCorrespondencia = dg;
    this.onChangeFormEmit();
  }

  direccionGeograficaOficinaStatusChange(s: any) {
    this.direccionGeograficaOficinaValid = s === 'VALID';
  }

  direccionGeograficaCorrespondenciaStatusChange(s: any) {
    this.direccionGeograficaCorrespondenciaValid = s === 'VALID';
  }

  direccionGeograficaFiscalStatusChange(s: any) {
    this.direccionGeograficaFiscalValid = s === 'VALID';
  }

  getInfoAcreditacion() {
    let info = '';
    // Administrativo responsable
    if (
      this.personaJuridicaFormGroup.get('rol').get('tipo_rol_id').value == 4
    ) {
      info =
        'Nota firmada por titular/representante legal o apoderado/a que avale la representación';
    } else {
      info = 'Mención en el certificado o carta poder';
    }
    return info;
  }

  // Telefonos
  telefonoFormValueChange(telefonos: any) {
    this.telefonos = telefonos;
    this.onChangeFormEmit();
  }

  telefonoFormStatusChange(s: any) {
    this.telefonosStatus = s;
    this.emitFormStatusChanges();
  }

  uploadNewCertificadoNotarial(): void {
    this.linkCertificadoNotarial = '';
    this.personaJuridicaFormGroup
      .get('persona_juridica')
      .get('certificado_notarial')
      .addValidators([Validators.required]);
    this.emitFormStatusChanges();
    this.onChangeFormEmit();
  }

  uploadNewAcreditacionRepresentacion(): void {
    this.acreditacionRepresentacionLink = '';
    this.personaJuridicaFormGroup
      .get('rol')
      .get('acreditacion_representacion')
      .setValidators([Validators.required]);
    this.emitFormStatusChanges();
    this.onChangeFormEmit();
  }

  // carga los datos de dgi en el formulario
  private loadDGIData(empresaDGI: EmpresaDGI): void {
    // Validar que la empresa esté activa en DGI
    if (empresaDGI.EstadoActividad !== 'A') {
      this.notificationService.error('La empresa no se encuentra activa en DGI. No se puede continuar con el registro.');
      this.empresaDGILoaded = false;
      this.onDGILoadedChange.emit(false);
      const personaJuridicaGroup = this.personaJuridicaFormGroup.get('persona_juridica');
      const rutControl = personaJuridicaGroup.get('rut');
      if (rutControl) {
        rutControl.enable({ emitEvent: false });
        rutControl.setValue('', { emitEvent: false });
      }
      return;
    }
  
    const personaJuridicaGroup = this.personaJuridicaFormGroup.get('persona_juridica');
    
    // RUT
    if (empresaDGI.RUT) {
      personaJuridicaGroup.patchValue({
        rut: empresaDGI.RUT
      }, { emitEvent: false });
      personaJuridicaGroup.get('rut').disable({ emitEvent: false });
    } else {
      personaJuridicaGroup.get('rut').enable({ emitEvent: false });
    }
  
    // Denominación social
    if (empresaDGI.Denominacion) {
      personaJuridicaGroup.patchValue({
        denominacion_social: empresaDGI.Denominacion
      }, { emitEvent: false });
      personaJuridicaGroup.get('denominacion_social').disable({ emitEvent: false });
    } else {
      personaJuridicaGroup.get('denominacion_social').enable({ emitEvent: false });
    }
  
    // Nombre fantasía
    if (empresaDGI.NombreFantasia) {
      personaJuridicaGroup.patchValue({
        nombre_fantasia: empresaDGI.NombreFantasia
      }, { emitEvent: false });
      personaJuridicaGroup.get('nombre_fantasia').disable({ emitEvent: false });
    } else {
      personaJuridicaGroup.get('nombre_fantasia').enable({ emitEvent: false });
    }
  
    // Domicilio constituido - UNA SOLA VEZ
    if (empresaDGI.Domicilio_constituido) {
      const direccionConstituida = this.mapDGIDomicilioToDireccionGeografica(
        empresaDGI.Domicilio_constituido
      );
      this.direccionGeograficaOficinaFormInput = direccionConstituida;
      
      setTimeout(() => {
        if (this.direccion_geografica_constituida) {
          this.direccion_geografica_constituida.setValues(direccionConstituida);
        }
      }, 100);
    }
  
    // Domicilio fiscal - UNA SOLA VEZ
    if (empresaDGI.Domicilio_fiscal) {
      const sonIguales = this.compararDomicilios(
        empresaDGI.Domicilio_fiscal,
        empresaDGI.Domicilio_constituido
      );
  
      const direccionFiscal = this.mapDGIDomicilioToDireccionGeografica(
        empresaDGI.Domicilio_fiscal
      );
  
      if (sonIguales) {
        this.mismoDomicilioFiscal = 'si';
        this.direccionGeograficaFiscalFormInput = direccionFiscal;
        this.handleDireccionGeograficaFiscal({ value: 'si' });
        setTimeout(() => {
          if (this.direccion_geografica_fiscal) {
            this.direccion_geografica_fiscal.setValues(direccionFiscal);
          }
        }, 0);

      } else {
        this.mismoDomicilioFiscal = 'no';
        this.direccionGeograficaFiscalFormInput = direccionFiscal;
        this.handleDireccionGeograficaFiscal({ value: 'no' });
        
        
        // Solo llamar setValues si son diferentes
        setTimeout(() => {
          if (this.direccion_geografica_fiscal) {
            this.direccion_geografica_fiscal.setValues(direccionFiscal);
          }
        }, 500);
      }
    }
  
    this.empresaDGILoaded = true;
    this.onDGILoadedChange.emit(true);
    
    this.cdr.detectChanges();
    this.onChangeFormEmit();
  }

  // habilita el formulario completo para ingreso manual cuando falla la conexion con dgi
  private enableManualEntry(): void {
    const personaJuridicaGroup = this.personaJuridicaFormGroup.get('persona_juridica');

    // se conserva el rut ingresado por el usuario y se bloquea para evitar reconsultas accidentales;
    // el boton "Volver" permite modificarlo
    const rutControl = personaJuridicaGroup.get('rut');
    if (rutControl.enabled) {
      rutControl.disable({ emitEvent: false });
    }

    // se habilitan los campos que normalmente completa DGI para que el usuario los ingrese
    personaJuridicaGroup.get('denominacion_social').enable({ emitEvent: false });
    personaJuridicaGroup.get('nombre_fantasia').enable({ emitEvent: false });

    this.entradaManual = true;
    this.empresaDGILoaded = true;
    this.onDGILoadedChange.emit(true);

    this.cdr.detectChanges();
    this.onChangeFormEmit();
  }

  // Compara dos domicilios de DGI para verificar si son iguales
  private compararDomicilios(domicilio1: Domicilio, domicilio2: Domicilio): boolean {
    if (!domicilio1 || !domicilio2) {
      return false;
    }
    return (
      domicilio1.direccion === domicilio2.direccion &&
      domicilio1.departamento_codigo === domicilio2.departamento_codigo &&
      domicilio1.localidad_id === domicilio2.localidad_id
    );
  }


  // mapea un domicilio de dgi a direccion geografica
  private mapDGIDomicilioToDireccionGeografica(domicilio: Domicilio): DireccionGeografica {
    // Limpiar la dirección que viene de DGI
    let direccionLimpia = domicilio.direccion || '';
    direccionLimpia = direccionLimpia.trim();
    
    // Quitar comas al inicio y al final
    while (direccionLimpia.startsWith(',')) {
      direccionLimpia = direccionLimpia.substring(1).trim();
    }
    while (direccionLimpia.endsWith(',')) {
      direccionLimpia = direccionLimpia.substring(0, direccionLimpia.length - 1).trim();
    }
    
    // Reemplazar múltiples comas por una sola
    direccionLimpia = direccionLimpia.replace(/,+/g, ',');
    
    // Reemplazar múltiples espacios por uno solo
    direccionLimpia = direccionLimpia.replace(/\s+/g, ' ');
    
    return {
      id: null,
      pais_codigo: 'uy',
      departamento_codigo: domicilio.departamento_codigo,
      localidad_id: domicilio.localidad_id,
      localidad_nombre: null,
      codigo_postal: null,
      direccion: direccionLimpia,
      longitud: null,
      latitud: null
    };
  }

  // valida si el rut es valido para consultar dgi
  isRutValidForConsult(): boolean {
    if (this.formInput.action !== FormActionType.Add) {
      return false;
    }
    const rutControl = this.personaJuridicaFormGroup.get('persona_juridica').get('rut');
    const rut = rutControl.value;
    return rut && rut.length === 12 && /^\d+$/.test(rut) && rutControl.valid;
  }

  // consulta dgi cuando se hace clic en el boton continuar
  consultarDGI(): void {
    if (this.formInput.action === FormActionType.Add) {
      const rutControl = this.personaJuridicaFormGroup.get('persona_juridica').get('rut');
      const rut = rutControl.value;
      
      if (rut && rut.length === 12 && /^\d+$/.test(rut)) {
        this.dgiConsultada = true;
        this.store.dispatch(entityEmpresaDGISetEmpty());
        this.store.dispatch(entityEmpresaDGILoadRequest({ rut }));
      }
    }
  }

  // resetea campos cuando cambia el rut
  private resetDGIFields(): void {
    const personaJuridicaGroup = this.personaJuridicaFormGroup.get('persona_juridica');
    
    if (personaJuridicaGroup.get('denominacion_social').disabled) {
      personaJuridicaGroup.patchValue({ denominacion_social: '' }, { emitEvent: false });
    }
    
    if (personaJuridicaGroup.get('nombre_fantasia').disabled) {
      personaJuridicaGroup.patchValue({ nombre_fantasia: '' }, { emitEvent: false });
    }

    this.empresaDGILoaded = false;
    this.entradaManual = false;
    this.dgiConsultada = false;
  }

  // vuelve al estado inicial mostrando solo el campo rut
  resetToRutOnly(): void {
    if (this.formInput.action === FormActionType.Add) {
      this.store.dispatch(entityEmpresaDGISetEmpty());
      this.empresaDGILoaded = false;
      this.entradaManual = false;
      this.dgiConsultada = false;
      this.onDGILoadedChange.emit(false);
      
      const personaJuridicaGroup = this.personaJuridicaFormGroup.get('persona_juridica');
      const rutControl = personaJuridicaGroup.get('rut');
      
      rutControl.patchValue('', { emitEvent: false });
      rutControl.markAsUntouched();
      rutControl.markAsPristine();
  
      if (rutControl.disabled) {
        rutControl.enable({ emitEvent: false });
      }
      
      const denominacionControl = personaJuridicaGroup.get('denominacion_social');
      denominacionControl.patchValue('', { emitEvent: false });
      denominacionControl.markAsUntouched();
      denominacionControl.markAsPristine();
      if (denominacionControl.disabled) {
        denominacionControl.enable({ emitEvent: false });
      }
      
      const nombreFantasiaControl = personaJuridicaGroup.get('nombre_fantasia');
      nombreFantasiaControl.patchValue('', { emitEvent: false });
      nombreFantasiaControl.markAsUntouched();
      nombreFantasiaControl.markAsPristine();
      if (nombreFantasiaControl.disabled) {
        nombreFantasiaControl.enable({ emitEvent: false });
      }
      
      this.direccionGeograficaOficinaFormInput = null;
      this.direccionGeograficaFiscalFormInput = null;
      this.direccionGeograficaCorrespondenciaFormInput = null;
      
      if (this.direccion_geografica_constituida) {
        this.direccion_geografica_constituida.limpiarCampos();
      }
      if (this.direccion_geografica_fiscal) {
        this.direccion_geografica_fiscal.limpiarCampos();
      }
      if (this.direccion_geografica_correspondencia) {
        this.direccion_geografica_correspondencia.limpiarCampos();
      }
      
      this.mismoDomicilioFiscal = 'si';
      this.mismoDomicilioCorrespondencia = 'si';
      
      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_correspondencia')
        .disable();
      
      this.personaJuridicaFormGroup
        .get('entidad_productiva')
        .get('direccion_geografica_fiscal')
        .disable();
      
      this.cdr.detectChanges();
    }
  }
}
